import { useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import { LoginWrapper } from '@commerce-identity-webcomponents/ui';
import { getLoginProps } from '../../utils/Utils';
import styles from './RegistrationSignIn.module.scss';
import { RegistrationSignInProps } from './types/propTypes';

const RegistrationSignIn = ({ sourceUrl }: RegistrationSignInProps) => {
  const t = useTranslation();
  const router = useNextgenRouter();
  return (
    <div className={styles['registration-already-user']} data-testid="registration-already-user">
      <span className={styles['alreacy-user-text']}>{t('profile.RegistrationSignIn.alreadyHasAccount')}</span>
      <span className={styles['registration-text-link']}>
        <LoginWrapper {...getLoginProps(router.params?.locale as string, sourceUrl)}>
          <span className={styles['signin-link']}>{t('profile.common.signInButton')}</span>
        </LoginWrapper>
      </span>
    </div>
  );
};
export default RegistrationSignIn;
